import React from 'react'
import { Route, Routes } from 'react-router'
import EssDashboardPage from '../app/ess/EssDashboard/pages/EssDashboardPage'
import EssAttendancePage from '../app/ess/EssAttendance/pages/EssAttendancePage'
import EssWorkReportPage from '../app/ess/EssWorkReport/pages/EssWorkReportPage'
import EssTaskPage from '../app/ess/EssTask/pages/EssTaskPage'
import EssLeaveRequestPage from '../app/ess/EssLeaveRequest/pages/EssLeaveRequestPage'
import EssArchivedTaskPage from '../app/ess/EssTask/pages/EssArchivedTaskPage'
import ESSAssignedProjectListPage from '../app/ess/ESSAssignedProject/pages/ESSAssignedProjectListPage'
import EssTeamListPage from '../app/ess/EssTeam/pages/EssTeamListPage'
import ESSTeamWorkReportPage from '../app/ess/EssWorkReport/pages/ESSTeamWorkReportPage'
import EssNotificationListPage from '../app/ess/EssNotification/pages/EssNotificationListPage'
import EssLeadPage from '../app/ess/EssLead/pages/EssLeadPage'


function EssRoutes() {
  return (
    <>
      <Routes>
        {/* Business Details */}
        <Route path="/" element={<EssDashboardPage />}></Route>
        <Route path="/attendance" element={<EssAttendancePage />}></Route>
        <Route path="/work-report" element={<EssWorkReportPage />}></Route>
        <Route path="/work-report/team" element={<ESSTeamWorkReportPage />}></Route>
        <Route path="/leave-request" element={<EssLeaveRequestPage />}></Route>
        <Route path="/task" element={<EssTaskPage />}></Route>
        
        <Route path="/archived-task" element={<EssArchivedTaskPage />}></Route>
        <Route path="/projects" element={<ESSAssignedProjectListPage />}></Route>

        <Route path="/team" element={<EssTeamListPage />}></Route>
        <Route path="/notifications" element={<EssNotificationListPage />}></Route>
      </Routes>
    </>
  )
}

export default EssRoutes